<template>
  <Modal
    ref="videoPopupRef"
    :showIcon="false"
    :clickToClose="true"
    :withCloser="true"
    class="product-detail-video-popup"
    :modalStyle="{
      width: '460px',
      height: 'auto',
      padding: '20px',
    }"
    negativeActionText="Vazgeç"
    positiveActionText="Eğitimi İzle"
    @onNegativeActionClick="handleClose"
    @onPositiveActionClick="openVideo"
    @modalClosed="handleModalClosed"
  >
    <template v-slot:body>
      <div class="video-popup-inner">
        <div class="video-area" @click="openVideo">
          <img
            :src="thumbnailSrc"
            alt="Eğitim videosu ön izleme"
            class="video-thumbnail"
          />
        </div>

        <div class="content">
          <h2 class="title">Ürün detay sayfamızı yeniledik</h2>
          <p class="description">
            Ürün detay sayfasını daha hızlı ve kolay yönetebilmen için yeniledik.
            Tüm değişiklikleri adım adım görmek için eğitim videosunu izleyebilirsin.
          </p>

          <div class="whats-new">
            <p class="whats-new-title">Neler yeni?</p>
            <ul class="whats-new-list">
              <li>Daha sade ve anlaşılır ekran tasarımı</li>
              <li>Alan bazlı kaydetme ile hızlı düzenleme</li>
              <li>Güncelleme/Hata Talep akışı ve talep durumu takibinde daha iyi deneyim</li>
              <li>
                Ürün varyantlarını ve aynı model koda sahip ürünleri tek ekranda
                görüntüleme ve güncelleme
              </li>
              <li>Ürün detay sayfasından pratik şekilde yeni varyant ekleme</li>
            </ul>
          </div>

        </div>
      </div>
    </template>
  </Modal>
</template>

<script setup>
import { ref } from 'vue';
import { Modal } from '@n11/so-ui-components';
import videoThumbnail from '@/assets/images/video-thumbnail.svg';
import { sendProductDetailEvent } from '@/utils/ga4/helper';
import { GA4_EVENT } from '@/utils/ga4/event';

const props = defineProps({
  videoUrl: {
    type: String,
    default: '',
  },
  productId: {
    type: [String, Number],
    default: null,
  },
});

const thumbnailSrc = videoThumbnail;

const videoPopupRef = ref(null);
const isDismissEventSent = ref(false);

const openPopup = () => {
  isDismissEventSent.value = false;
  videoPopupRef.value?.openModal();
};

const handleClose = () => {
  if (!isDismissEventSent.value) {
    sendProductDetailEvent(GA4_EVENT.WATCH_TUTORIAL_DISMISS, {
      button_name: 'Vazgeç',
      button_type: 'Report a Bug',
      button_area: 'Page Up',
      item_id: props.productId,
    });
    isDismissEventSent.value = true;
  }
  videoPopupRef.value?.hiddenModal();
};
const handleModalClosed = () => {
  if (!isDismissEventSent.value) {
    sendProductDetailEvent(GA4_EVENT.WATCH_TUTORIAL_DISMISS, {
      button_name: 'Vazgeç',
      button_type: 'Report a Bug',
      button_area: 'Page Up',
      item_id: props.productId,
    });
    isDismissEventSent.value = true;
  }
};
const openVideo = () => {
  sendProductDetailEvent(GA4_EVENT.WATCH_TUTORIAL, {
    button_name: 'Eğitimi İzle',
    button_type: 'Watch Tutorial',
    button_area: 'Page Up',
    item_id: props.productId,
  });
  isDismissEventSent.value = true; // Prevent dismiss event when closing after video click
  if (props.videoUrl) {
    window.open(props.videoUrl, '_blank');
  }
  videoPopupRef.value?.hiddenModal();
};

defineExpose({ openPopup });
</script>

<style scoped lang="scss">
@import '@/assets/styles/variables.scss';


.video-popup-inner {
  display: flex;
  flex-direction: column;
  font-size: 16px;
  font-weight: 400;
  line-height: 24px;
  letter-spacing: -0.05px;
  text-align: left;
  margin-top: 10px;

  .video-area {
    position: relative;
    border-radius: 8px;
    overflow: hidden;
    cursor: pointer;

    .video-thumbnail {
      width: 100%;
      display: block;
      object-fit: cover;
    }

    .play-icon-wrapper {
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
    }
  }

  .description {
    margin-bottom: 16px;
  }

  .whats-new-list,
  .description {
    font-size: 16px;
    font-weight: 400;
    line-height: 24px;
    letter-spacing: -0.05px;
  }

  .title {
    font-size: 20px;
    font-weight: 700;
    line-height: 26px;
    letter-spacing: -0.2px;
    margin: 24px 0px 16px 0px;
  }

  .whats-new-list {
    list-style-type: disc;
    padding-left: 20px;
  }

  .whats-new-title {
    font-size: 18px;
    font-weight: 700;
    line-height: 22px;
    letter-spacing: -0.1px;
    margin-bottom: 16px;
  }
}
</style>
